<template>
  <CockpitDialog class="alarm-List_dialog" title="报警列表" @close="close">
    <div>
      <el-select
        class="mr-10px"
        v-model="search.prLevel"
        placeholder="故障等级"
        size="small"
        clearable
      >
        <el-option
          v-for="(item, index) in levelList"
          :key="index"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        type="datetimerange"
        range-separator="至"
        v-model="dateRange"
        start-placeholder="报警日期"
        end-placeholder="报警日期"
        size="small"
        clearable
      ></el-date-picker>
      <el-button class="ml-10px" type="default" size="mini" @click="searchList">搜索</el-button>
    </div>
    <el-table
      ref="tableRef"
      height="calc(100% - 100px)"
      class="mt-20px"
      :data="tableData"
      highlight-current-row
      row-key="id"
    >
      <el-table-column width="60" label="序号" type="index"></el-table-column>
      <el-table-column label="故障信息" prop="prDesc" show-overflow-tooltip> </el-table-column>
      <el-table-column label="故障等级" prop="" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.prLevel === 1" class="text-[#feff00]">告警</span>
          <span v-if="scope.row.prLevel === 2" class="text-[#feb600]">严重</span>
          <span v-if="scope.row.prLevel === 3" class="text-red-500">致命</span>
        </template>
      </el-table-column>
      <el-table-column label="报警时间" prop="prAlarmtime" show-overflow-tooltip> </el-table-column>
      <el-table-column label="操作" width="75px">
        <template slot-scope="scope">
          <div class="cursor-pointer text-[#00BCC8]" @click.stop="toDetail(scope.row)">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="pageInfo.total"
      :current-page.sync="pageInfo.pageNo"
      :page-size.sync="pageInfo.pageSize"
      class="h-35px mt-5px text-center"
      layout="total, prev, pager, next"
      @current-change="getAccessControlOrBarrierGateDetail()"
      :pager-count="5"
    >
    </el-pagination>
    <AlarmDetailDialog
      v-if="isShowAlarmsDetailDialog"
      class="w-500px h-260px"
      @refresh="refresh"
      :propsData="rowData"
    />
  </CockpitDialog>
</template>

<script>
import { LightingDeviceApi } from '@wiz-api/huizhou2-business'
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import dayjs from 'dayjs'
import AlarmDetailDialog from './alarmDetailDialog'

const lightingDeviceApi = new LightingDeviceApi()
export default {
  name: 'alarmListDialog',
  components: {
    CockpitDialog,
    AlarmDetailDialog,
  },
  props: {},
  data() {
    return {
      tableData: [],
      pageInfo: {
        total: 0,
        pageSize: 10,
        pageNo: 1,
      },
      search: {
        prLevel: null,
        startAlarmtime: '',
        endAlarmtime: '',
      },
      dateRange: [],
      levelList: [
        { label: '告警', value: 1 },
        { label: '严重', value: 2 },
        { label: '致命', value: 3 },
      ],
      isShowAlarmsDetailDialog: false,
    }
  },
  created() {
    this.getAlarms()
  },
  methods: {
    close() {
      this.isShow = false
      this.$emit('refresh', false)
    },
    // 刷新
    refresh() {
      this.isShowAlarmsDetailDialog = false
    },
    // 查询
    searchList() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.search.startAlarmtime = dayjs(this.dateRange[0]).format('YYYY-MM-DD HH:mm:ss')
        this.search.endAlarmtime = dayjs(this.dateRange[1]).format('YYYY-MM-DD HH:mm:ss')
      } else {
        delete this.search.startAlarmtime
        delete this.search.endAlarmtime
      }
      this.pageInfo.pageNo = 1
      this.getAlarms(this.search)
    },
    // 获取报警列表
    async getAlarms(search) {
      this.tableLoading = true
      const [err, res] = await lightingDeviceApi.getLightingDeviceAlarmList({
        body: {
          maxResultCount: this.pageInfo.pageSize,
          skipCount: (this.pageInfo.pageNo - 1) * this.pageInfo.pageSize,
          ...search,
        },
      })
      if (!err) {
        this.tableData = res.items
        this.pageInfo.total = res.totalCount
      }
      this.tableLoading = false
    },
    // 详情
    toDetail(row) {
      this.isShowAlarmsDetailDialog = true
      this.rowData = row
    },
  },
}
</script>
<style lang="scss" scoped>
.alarm-List_dialog {
  left: 520px;
  top: 200px;
}
</style>
